import { Archivo } from 'portalba360';

export const state = {
    archivo: new Archivo()
};
export const mutations = {

};
export const getters = {

};
export const actions = {
    async getAllFiles({ state }, data) {
        try {
            let response = await state.archivo.all(data);
            return response.data;
        } catch (e) {
            return console.log(e)
        }
    },
    async addFile({ state }, data) {
        try {
            let response = await state.archivo.add(data);
            return response.data;
        } catch (e) {
            return console.log(e)
        }
    },
    async downloadFile({ state }, data) {
        try {
            let response = await state.archivo.download(data);
            return response.data;
        } catch (e) {
            return console.log(e)
        }
    }
};